import {Component, OnInit, ViewChild} from "@angular/core";
import {SeoServiceService} from "@xref/ngx";
import * as Cookies from "js-cookie";
import Constants from "../../shared/constants";
import {environment} from "../../../environments/environment";
import {ActivatedRoute} from "@angular/router";
import {IdService} from "../../services/id/id.service";
import {MarketingService} from "../../services/marketing/marketing.service";
import {PermissionsService} from "../../services/permissions/permissions.service";

@Component({
    selector: "xlog-login",
    templateUrl: "./login.component.pug",
    styleUrls: ["./login.component.scss"],
    standalone: false
})
export class LoginComponent implements OnInit {
    @ViewChild("loginForm") loginForm: any;

    userLoggedIn: boolean;
    userName: string;
    appAccess: boolean;

    isPendingVerification = false;
    pendingVerificationEmail = "";

    constructor(
        private id: IdService,
        private route: ActivatedRoute,
        private seoService: SeoServiceService,
        private marketing: MarketingService,
        private featureFlagService: PermissionsService
    ) {}

    ngOnInit() {
    // Update meta tags
        this.route.data.subscribe((data) => {
            this.seoService.updateDescription(data.description);
            this.seoService.updateTitle(data.title);
        });

        this.isUserLoggedIn();

        // Clear any previous region Cookies if user is not already logged in
        if (!this.userLoggedIn) {
            Cookies.remove(Constants.API_REGION_TOKEN, {
                domain: environment.DOMAIN,
            });
        }

        this.marketing.setMarketingResource('login-marketing-section');
        this.id.ent_9105 = this.featureFlagService.isFeatureActivated('ENT-9105-PENETRATION-TEST-2025');
    }

    // Make sure user is logged in
    // Check both the local token existence and if employer data is retrievable
    isUserLoggedIn() {
        this.userLoggedIn = this.id.loggedIn();
        if (this.userLoggedIn) {
            if (this.id.ent_9105) {
                this.id.redirectToReturnUrl();
            } else {
                this.id.DeprecatedRedirectToReturnUrl();
            }
        } else {
            this.id.removeToken();
        }
    }
}
